module.exports = __webpack_public_path__ + "img/catering_menu_8.bd3f159a.jpg";